var React = require('react');

function BigData (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M18 14C23.5228 14 28 12.433 28 10.5C28 8.567 23.5228 7 18 7C12.4772 7 8 8.567 8 10.5C8 12.433 12.4772 14 18 14Z","stroke":"#5B59FB","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M28 18C28 19.66 23.5556 21 18 21C12.4444 21 8 19.66 8 18","stroke":"#5B59FB","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M8 10V25.6471C8 27.5024 12.4444 29 18 29C23.5556 29 28 27.5024 28 25.6471V10","stroke":"#5B59FB","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

BigData.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = BigData;

BigData.default = BigData;
